var map = {
	"./Img-01.jpg": 78609,
	"./Img-02.jpg": 75472,
	"./Img-03.jpg": 91660,
	"./Img-05.jpg": 53261,
	"./Img-07.jpg": 51758,
	"./K.png": 56443,
	"./abies_PINECONE_full_angled-300px-01.png": 82175,
	"./abies_PINECONE_full_angled-300px_w-01.png": 96600,
	"./abies_logo_500-300px-01.png": 21401,
	"./abies_logo_500-300px_w-01.png": 91125,
	"./b.png": 47878,
	"./blog-grid/author_img.png": 19189,
	"./blog-grid/blog_list1.jpg": 36222,
	"./blog-grid/blog_list2.jpg": 57316,
	"./blog-grid/blog_list3.jpg": 27197,
	"./blog-grid/blog_list4.jpg": 3033,
	"./blog-grid/blog_single.png": 91426,
	"./blog-grid/comment1.png": 36402,
	"./blog-grid/comment2.png": 7845,
	"./blog-grid/post_1.jpg": 83806,
	"./blog-grid/post_2.jpg": 96090,
	"./blog-grid/post_3.jpg": 75166,
	"./blog-grid/post_4.jpg": 1387,
	"./blog-grid/post_img_1.png": 77508,
	"./blog-grid/post_img_2.png": 87138,
	"./blog-grid/post_img_3.png": 40098,
	"./br_logo.png": 77954,
	"./breadcrumb/banner_bg.png": 40891,
	"./breadcrumb/service.png": 93744,
	"./breadcrumb/service_details.png": 41170,
	"./breadcrumb/service_details_one.png": 70055,
	"./cart1.jpg": 45708,
	"./cart2.jpg": 46297,
	"./erp-home/action_img.png": 3114,
	"./erp-home/background.png": 12111,
	"./erp-home/banner_shap.png": 74643,
	"./erp-home/cloud-computing.png": 61490,
	"./erp-home/cloud_01.png": 65886,
	"./erp-home/cloud_02.png": 81026,
	"./erp-home/cloud_03.png": 78328,
	"./erp-home/cloud_04.png": 98422,
	"./erp-home/cloud_05.png": 62948,
	"./erp-home/cloud_06.png": 41133,
	"./erp-home/crm_img1.jpg": 55059,
	"./erp-home/crm_img2.jpg": 4742,
	"./erp-home/crm_img3.jpg": 20375,
	"./erp-home/erp_dashboard.jpg": 20851,
	"./erp-home/erp_icon1.png": 73750,
	"./erp-home/erp_icon2.png": 36956,
	"./erp-home/erp_icon3.png": 90124,
	"./erp-home/erp_icon4.png": 2680,
	"./erp-home/erp_icon5.png": 17114,
	"./erp-home/erp_icon6.png": 91761,
	"./erp-home/growth.png": 53456,
	"./erp-home/img/01.png": 43968,
	"./erp-home/img/02.png": 42646,
	"./erp-home/img/03.png": 37601,
	"./erp-home/img/04.png": 14724,
	"./erp-home/img/05.png": 5496,
	"./erp-home/img/06.png": 9829,
	"./erp-home/img/07.png": 66597,
	"./erp-home/img/08.png": 6749,
	"./erp-home/img/09.png": 92251,
	"./erp-home/img/10.png": 86976,
	"./erp-home/img/11.png": 44252,
	"./erp-home/img/12.png": 97480,
	"./erp-home/img/13.png": 89576,
	"./erp-home/img/14.png": 845,
	"./erp-home/img/15.png": 927,
	"./erp-home/img/16.png": 40215,
	"./erp-home/img/17.png": 8142,
	"./erp-home/img/18.png": 79593,
	"./erp-home/img/19.png": 73369,
	"./erp-home/img/20.png": 37117,
	"./erp-home/quote.png": 68830,
	"./erp-home/rocket.png": 72931,
	"./erp-home/settings1.png": 99784,
	"./erp-home/shape.png": 73825,
	"./erp-home/testimonial_img.jpg": 31845,
	"./erp-home/testimonial_img2.jpg": 29936,
	"./error_bg.png": 7570,
	"./favicon.png": 33750,
	"./home-chat/Messages.jpg": 29933,
	"./home-chat/Messages.png": 14110,
	"./home-chat/book.png": 6474,
	"./home-chat/box.png": 19001,
	"./home-chat/chat.png": 13758,
	"./home-chat/chat_01.png": 61677,
	"./home-chat/chat_02.png": 76781,
	"./home-chat/chat_icon.png": 4574,
	"./home-chat/cloud.png": 54993,
	"./home-chat/dashboard.png": 9779,
	"./home-chat/dot.png": 36097,
	"./home-chat/get_started_bg.png": 85837,
	"./home-chat/john.png": 71096,
	"./home-chat/left_leaf.png": 58183,
	"./home-chat/live_chat.png": 601,
	"./home-chat/mobile.png": 78039,
	"./home-chat/panguin_img_one.png": 10129,
	"./home-chat/panguin_img_three.png": 19043,
	"./home-chat/panguin_img_two.png": 37580,
	"./home-chat/pluse.png": 96771,
	"./home-chat/richard.png": 78935,
	"./home-chat/right_leaf.png": 38693,
	"./home-chat/skyp_1.png": 37181,
	"./home-chat/skyp_2.png": 9105,
	"./home-chat/support_dashboard.jpg": 49085,
	"./home-chat/triangle.png": 26278,
	"./home-chat/video_icon.png": 22025,
	"./home-event/about.jpg": 91320,
	"./home-event/banner_bg.jpg": 18101,
	"./home-event/chat.png": 48543,
	"./home-event/conference.jpg": 88076,
	"./home-event/digital.jpg": 91365,
	"./home-event/dot.png": 31687,
	"./home-event/image_01.jpg": 70713,
	"./home-event/image_02.jpg": 91467,
	"./home-event/image_03.jpg": 97993,
	"./home-event/image_04.jpg": 78136,
	"./home-event/image_05.jpg": 91474,
	"./home-event/image_06.jpg": 80860,
	"./home-event/instragram1.jpg": 85454,
	"./home-event/instragram2.jpg": 31731,
	"./home-event/instragram3.jpg": 55720,
	"./home-event/instragram4.jpg": 79401,
	"./home-event/instragram5.jpg": 20344,
	"./home-event/instragram6.jpg": 55891,
	"./home-event/leader.png": 97618,
	"./home-event/logo_09.jpg": 74410,
	"./home-event/logo_10.jpg": 60439,
	"./home-event/logo_11.jpg": 4923,
	"./home-event/logo_12.jpg": 34650,
	"./home-event/marker.png": 11961,
	"./home-event/marketing.jpg": 15954,
	"./home-event/meetup.png": 23054,
	"./home-event/price_shap.png": 7587,
	"./home-event/promo.jpg": 74956,
	"./home-event/team1.jpg": 74249,
	"./home-event/team2.jpg": 46644,
	"./home-event/team3.jpg": 37439,
	"./home-event/timer.png": 29890,
	"./home-security/about_img_1.jpg": 24259,
	"./home-security/about_img_2.jpg": 83901,
	"./home-security/apple_icon.png": 72958,
	"./home-security/banner.png": 43802,
	"./home-security/leaf_clients1.png": 45709,
	"./home-security/leaf_clients2.png": 25998,
	"./home-security/mackbook.png": 67035,
	"./home-security/padlock.png": 89138,
	"./home-security/real-estate.png": 60599,
	"./home-security/rocket.png": 12679,
	"./home-security/security_1.png": 19729,
	"./home-security/security_2.png": 24693,
	"./home-security/security_3.png": 43133,
	"./home-security/security_4.png": 45712,
	"./home-security/shap.png": 79489,
	"./home-security/sheld_bg.png": 55928,
	"./home-security/shield.png": 93800,
	"./home-security/windows_icon.png": 83080,
	"./home-software/analytices1.png": 23529,
	"./home-software/analytices2.png": 4840,
	"./home-software/analytices3.png": 63869,
	"./home-software/analytices4.png": 36226,
	"./home-software/analytices5.jpg": 14425,
	"./home-software/analytices6.jpg": 44669,
	"./home-software/analytices7.jpg": 52983,
	"./home-software/analytices8.jpg": 29548,
	"./home-software/case.png": 62433,
	"./home-software/down_bg.png": 1449,
	"./home-software/elements_five.png": 68102,
	"./home-software/elements_four.png": 78549,
	"./home-software/elements_one.png": 86889,
	"./home-software/elements_six.png": 57075,
	"./home-software/elements_three.png": 5814,
	"./home-software/elements_two.png": 37953,
	"./home-software/line_02.png": 20959,
	"./home-software/logo_01.png": 60168,
	"./home-software/logo_02.png": 42484,
	"./home-software/logo_03.png": 27255,
	"./home-software/logo_04.png": 18346,
	"./home-software/logo_05.png": 6091,
	"./home-software/logo_06.png": 45206,
	"./home-software/logo_07.png": 66576,
	"./home-software/logo_08.png": 59730,
	"./home-software/logo_09.png": 12737,
	"./home-software/logo_10.png": 23166,
	"./home-software/logo_11.png": 55838,
	"./home-software/logo_12.png": 71173,
	"./home-software/mackbook.png": 54986,
	"./home-software/pie.png": 48869,
	"./home-software/setup_img1.png": 88072,
	"./home-software/setup_img2.png": 85567,
	"./home-software/setup_img3.png": 24012,
	"./home-software/shap_3.png": 11054,
	"./home-software/shap_one.png": 82443,
	"./home-software/shap_two.png": 94525,
	"./home-tracking/activity_icon.png": 85684,
	"./home-tracking/aliexpress.png": 51613,
	"./home-tracking/amazon.png": 16480,
	"./home-tracking/analyze_icon.png": 50071,
	"./home-tracking/apple.png": 36158,
	"./home-tracking/computer_tracking_img.jpg": 81269,
	"./home-tracking/crismas.png": 32648,
	"./home-tracking/cta.png": 97393,
	"./home-tracking/cta_pattern_bg.jpg": 54495,
	"./home-tracking/google.png": 69254,
	"./home-tracking/left-dot.png": 38952,
	"./home-tracking/month.png": 87205,
	"./home-tracking/right-dot.png": 8957,
	"./home-tracking/tesla.png": 64108,
	"./home-tracking/time_icon.png": 18087,
	"./home-tracking/tracking_banner_img.png": 59262,
	"./home-tracking/watch_1.png": 46551,
	"./home-tracking/windows.png": 35125,
	"./home2/action_bg.png": 13473,
	"./home2/file.png": 6751,
	"./home2/inbox.png": 33578,
	"./home2/report.png": 31177,
	"./home2/undraw.png": 6412,
	"./home3/action_image.png": 59499,
	"./home3/dimond.png": 9741,
	"./home3/logo_01.png": 98136,
	"./home3/logo_02.png": 6303,
	"./home3/logo_03.png": 42767,
	"./home3/logo_04.png": 19207,
	"./home3/logo_05.png": 72141,
	"./home3/p_feature1.png": 95800,
	"./home3/prototype_banner_img.png": 51682,
	"./home3/prototype_banner_img2.png": 67242,
	"./home3/psd.png": 93749,
	"./home3/saas.png": 31759,
	"./home3/tab.png": 25250,
	"./home4/action_shap.png": 6079,
	"./home4/author_img.png": 46224,
	"./home4/banner_bg.png": 95348,
	"./home4/banner_img.png": 61938,
	"./home4/divider.png": 79261,
	"./home4/dot.png": 39678,
	"./home4/icon01.png": 92253,
	"./home4/icon02.png": 75390,
	"./home4/icon3.png": 89884,
	"./home4/icon_04.png": 30909,
	"./home4/icon_05.png": 40083,
	"./home4/icon_shape1.png": 60071,
	"./home4/icon_shape2.png": 9876,
	"./home4/icon_shape3.png": 30505,
	"./home4/icon_shape4.png": 70083,
	"./home4/process_1.png": 19041,
	"./home4/process_2.png": 18288,
	"./home4/process_3.png": 51507,
	"./home4/process_4.png": 40327,
	"./home4/process_5.png": 17291,
	"./home4/shape.png": 332,
	"./home4/team1.jpg": 15354,
	"./home4/team2.jpg": 80533,
	"./home4/work1.png": 4930,
	"./home4/work2.png": 82107,
	"./home4/work3.png": 91228,
	"./home5/01.jpg": 85731,
	"./home5/02.jpg": 23506,
	"./home5/03.jpg": 7075,
	"./home5/banner_img.png": 69585,
	"./home5/code.jpg": 37761,
	"./home5/design1.png": 81378,
	"./home5/design2.png": 58257,
	"./home5/design3.png": 98097,
	"./home5/featured_bg_shape.png": 80718,
	"./home5/featured_img1.png": 17028,
	"./home5/icon1.png": 8409,
	"./home5/icon2.png": 32437,
	"./home5/icon3.png": 76625,
	"./home5/icon_shape.png": 35288,
	"./home5/php.jpg": 77724,
	"./home5/shap_tecture.png": 85346,
	"./home6/dashboard.jpg": 64352,
	"./home6/featured_img_one.jpg": 5676,
	"./home6/featured_img_two.jpg": 87957,
	"./home6/feedback_img_one.png": 86826,
	"./home6/feedback_img_three.png": 46062,
	"./home6/feedback_img_two.png": 99664,
	"./home6/logo_01.png": 42155,
	"./home6/logo_02.png": 32026,
	"./home6/logo_03.png": 74076,
	"./home6/logo_04.png": 395,
	"./home6/logo_05.png": 96453,
	"./home6/shape-1.png": 32344,
	"./home6/shape2.png": 58208,
	"./home6/trust_img.png": 12733,
	"./home6/trust_img2.png": 3817,
	"./home7/01.png": 63284,
	"./home7/02.png": 47900,
	"./home7/03.png": 83925,
	"./home7/app.png": 2751,
	"./home7/banner.png": 71692,
	"./home7/google_icon.png": 54387,
	"./home7/iPhoneX2.png": 25905,
	"./home7/iPhonex.png": 27249,
	"./home7/screenshot1.png": 47446,
	"./home7/screenshot2.png": 63762,
	"./home7/screenshot3.png": 56016,
	"./home7/screenshot4.png": 87909,
	"./home7/screenshot5.png": 46496,
	"./home7/team_01.jpg": 76785,
	"./home7/team_02.jpg": 888,
	"./home7/team_03.jpg": 11430,
	"./home7/team_04.jpg": 89234,
	"./home7/testimonial_author_img.png": 94922,
	"./home7/text_one.png": 4670,
	"./home7/text_three.png": 53139,
	"./home7/text_two.png": 25073,
	"./home8/banner_img.png": 80219,
	"./home8/dot.png": 72393,
	"./home8/fact.png": 82966,
	"./home8/service_item_03.png": 12417,
	"./home9/featured_img.png": 37567,
	"./home9/featured_img_two.png": 77326,
	"./home9/flag.png": 47370,
	"./home9/footer.png": 90631,
	"./home9/icon1.png": 14438,
	"./home9/icon2.png": 92830,
	"./home9/icon3.png": 2211,
	"./home9/icon4.png": 57511,
	"./home9/icon5.png": 45241,
	"./home9/icon6.png": 52941,
	"./home9/icon7.png": 19420,
	"./home9/icon8.png": 49041,
	"./home9/icon_shape.png": 34905,
	"./home9/icon_shape_two.png": 11015,
	"./home9/logo1.png": 95648,
	"./home9/logo2.png": 77677,
	"./home9/logo3.png": 87645,
	"./home9/logo4.png": 9758,
	"./home9/logo5.png": 63740,
	"./home9/logo6.png": 10885,
	"./home9/logo7.png": 41134,
	"./home9/logo8.png": 35555,
	"./home9/mac.png": 68971,
	"./home9/map.png": 10286,
	"./home9/shape-footer.png": 51458,
	"./home9/shape.png": 43640,
	"./home9/shape_two.png": 30218,
	"./home9/testimonial_img.png": 39879,
	"./home9/testimonial_img2.png": 21498,
	"./home9/triangle_bottom.png": 10248,
	"./home9/triangle_top.png": 79270,
	"./hosting/action_img.png": 62033,
	"./hosting/business1.png": 74204,
	"./hosting/business2.png": 43277,
	"./hosting/h_blog1.jpg": 30962,
	"./hosting/h_blog2.jpg": 44513,
	"./hosting/hosting-image.png": 46231,
	"./hosting/hosting_action_bg.png": 98224,
	"./hosting/icon1.png": 29849,
	"./hosting/icon10.png": 9012,
	"./hosting/icon2.png": 10807,
	"./hosting/icon3.png": 6678,
	"./hosting/icon4.png": 33242,
	"./hosting/icon5.png": 69538,
	"./hosting/icon6.png": 4038,
	"./hosting/icon7.png": 44337,
	"./hosting/icon8.png": 12162,
	"./hosting/icon9.png": 97930,
	"./hosting/line_01.png": 88722,
	"./hosting/line_02.png": 45745,
	"./hosting/line_03.png": 27848,
	"./hosting/line_04.png": 2643,
	"./hosting/line_05.png": 68856,
	"./hosting/line_06.png": 27735,
	"./hosting/line_07.png": 64061,
	"./hosting/line_08.png": 21106,
	"./hosting/map.png": 68942,
	"./hosting/region_map.png": 15369,
	"./login_img.png": 15423,
	"./login_img2.png": 90040,
	"./logo-3-2x.png": 82432,
	"./logo-sticky-2x.png": 95105,
	"./logo-sticky.png": 85364,
	"./logo-sticky2.png": 12055,
	"./logo-sticky3.png": 23502,
	"./logo-sticky4.png": 46800,
	"./logo.png": 81053,
	"./logo2.png": 53603,
	"./logo2x-2.png": 72383,
	"./logo2x.png": 83349,
	"./logo3.png": 48837,
	"./logo4.png": 1228,
	"./logo7.png": 23019,
	"./logo8.png": 23815,
	"./mega-menu-img/Prototyping_Tool.jpg": 19630,
	"./mega-menu-img/analytices.jpg": 21261,
	"./mega-menu-img/coming_img.jpg": 23816,
	"./mega-menu-img/erp.jpg": 65936,
	"./mega-menu-img/home-animation.jpg": 2526,
	"./mega-menu-img/home-chat.jpg": 22354,
	"./mega-menu-img/home-event.jpg": 47874,
	"./mega-menu-img/home-security.jpg": 35981,
	"./mega-menu-img/home-track.jpg": 33472,
	"./mega-menu-img/home1.jpg": 47675,
	"./mega-menu-img/home10.jpg": 47340,
	"./mega-menu-img/home11.jpg": 5906,
	"./mega-menu-img/home12.jpg": 49574,
	"./mega-menu-img/home13.jpg": 16412,
	"./mega-menu-img/home14.jpg": 9393,
	"./mega-menu-img/home15.jpg": 8020,
	"./mega-menu-img/home16.jpg": 93293,
	"./mega-menu-img/home17.jpg": 79345,
	"./mega-menu-img/home2.jpg": 93466,
	"./mega-menu-img/home3.jpg": 69258,
	"./mega-menu-img/home4.jpg": 22173,
	"./mega-menu-img/home5.jpg": 54463,
	"./mega-menu-img/home6.jpg": 59988,
	"./mega-menu-img/home7.jpg": 75743,
	"./mega-menu-img/home8.jpg": 35889,
	"./mega-menu-img/home9.jpg": 41244,
	"./mega-menu-img/hosting.jpg": 88047,
	"./mega-menu-img/icon/app-d.png": 34569,
	"./mega-menu-img/icon/blup.png": 65194,
	"./mega-menu-img/pos.jpg": 88313,
	"./mega-menu-img/saas2-slider.png": 72787,
	"./mega-menu-img/support.jpg": 38443,
	"./new-home/back_bg.png": 1951,
	"./new-home/banner.png": 58048,
	"./new-home/briteverify.png": 50022,
	"./new-home/campfire.png": 12717,
	"./new-home/email.png": 4053,
	"./new-home/kissmetrics.png": 75809,
	"./new-home/metorik.png": 38458,
	"./new-home/nicereply-1.png": 70827,
	"./new-home/p-1.png": 66526,
	"./new-home/p-2.png": 11786,
	"./new-home/p-3.png": 73886,
	"./new-home/tab.png": 77021,
	"./new-home/tab_2.png": 25967,
	"./new-home/tab_3.png": 3399,
	"./new-home/ticket-support.png": 57464,
	"./new-home/tree-left.png": 15126,
	"./new-home/tree-right.png": 74209,
	"./new-home/tree.png": 66521,
	"./new-home/update.png": 4073,
	"./new-home/webhooks.png": 73978,
	"./new-home/wedsite.png": 64165,
	"./new/01.png": 47816,
	"./new/0111.png": 99647,
	"./new/02.png": 58269,
	"./new/0222.png": 49929,
	"./new/03.png": 87463,
	"./new/04.png": 18896,
	"./new/05.png": 97865,
	"./new/06.png": 24728,
	"./new/app_screen.png": 42820,
	"./new/blog/blog_grid_1.jpg": 28317,
	"./new/blog/blog_grid_2.jpg": 46069,
	"./new/blog/blog_grid_3.jpg": 75895,
	"./new/blog/blog_grid_4.jpg": 69006,
	"./new/blog/blog_grid_5.jpg": 22358,
	"./new/blog/blog_grid_6.jpg": 17573,
	"./new/blog/blog_grid_7.jpg": 99122,
	"./new/blog/blog_grid_8.jpg": 10622,
	"./new/case/case_01.jpg": 77197,
	"./new/case/case_02.jpg": 53395,
	"./new/case/case_03.jpg": 28957,
	"./new/case/case_04.jpg": 3858,
	"./new/case/case_05.jpg": 18025,
	"./new/case/case_06.jpg": 75265,
	"./new/case/case_07.jpg": 38063,
	"./new/case/case_08.jpg": 78245,
	"./new/case/case_09.jpg": 21238,
	"./new/case/case_10.jpg": 67738,
	"./new/case/case_11.jpg": 2034,
	"./new/case/case_12.jpg": 46892,
	"./new/case/case_details_01.jpg": 99656,
	"./new/case/case_details_02.jpg": 86493,
	"./new/case/case_details_03.jpg": 38287,
	"./new/case/parallax.png": 68346,
	"./new/coming_soon_bg.png": 71891,
	"./new/company.jpg": 33398,
	"./new/cup.png": 50328,
	"./new/digital_img.png": 35066,
	"./new/error.png": 15513,
	"./new/features_01.png": 70882,
	"./new/feedback_shap.png": 28442,
	"./new/home-split/contact.png": 94772,
	"./new/iPhoneX.png": 62646,
	"./new/icon.png": 33214,
	"./new/icon/icon1.png": 95498,
	"./new/icon/icon2.png": 55711,
	"./new/icon2.png": 88604,
	"./new/icon3.png": 94843,
	"./new/intregration_1.png": 90477,
	"./new/intregration_2.png": 78007,
	"./new/intregration_3.png": 20381,
	"./new/intregration_4.png": 28012,
	"./new/laptop.png": 78569,
	"./new/laptop_two.png": 8432,
	"./new/leaf.png": 51790,
	"./new/line_01.png": 42367,
	"./new/line_02.png": 73549,
	"./new/line_03.png": 16509,
	"./new/logo_01.png": 63687,
	"./new/logo_02.png": 4752,
	"./new/logo_03.png": 46080,
	"./new/logo_04.png": 88624,
	"./new/logo_05.png": 20168,
	"./new/member_01.jpg": 77374,
	"./new/new_shape.png": 96961,
	"./new/phone.png": 31122,
	"./new/price_bg.png": 10164,
	"./new/shape_bg.png": 99452,
	"./new/solution_01.jpg": 16784,
	"./new/solution_02.jpg": 28576,
	"./new/startup_banner_bg.png": 21247,
	"./new/startup_banner_img.png": 78457,
	"./new/startup_shap.png": 44286,
	"./new/tab_shape_bg.png": 70150,
	"./new/testimonial_bg.png": 86444,
	"./new/testimonial_bg_shap.png": 33451,
	"./new/testimonial_bg_two.png": 62492,
	"./new/video_bg.jpg": 25554,
	"./new/video_img_01.png": 45868,
	"./new/video_img_02.jpg": 32932,
	"./new/web_image.jpg": 41034,
	"./new_logo.png": 19225,
	"./portfolio-details/pr_details1.jpg": 13779,
	"./portfolio-details/pr_details2.jpg": 25962,
	"./portfolio-details/pr_details3.jpg": 95114,
	"./portfolio-details/pr_details4.jpg": 3797,
	"./portfolio/2-columns/grid1.jpg": 78690,
	"./portfolio/2-columns/grid2.jpg": 8466,
	"./portfolio/2-columns/grid3.jpg": 54928,
	"./portfolio/2-columns/grid4.jpg": 1207,
	"./portfolio/2-columns/grid5.jpg": 68050,
	"./portfolio/2-columns/grid6.jpg": 22851,
	"./portfolio/2-columns/grid7.jpg": 11126,
	"./portfolio/2-columns/grid8.jpg": 97344,
	"./portfolio/3-columns/3_col_1.jpg": 9671,
	"./portfolio/3-columns/3_col_10.jpg": 19193,
	"./portfolio/3-columns/3_col_11.jpg": 60129,
	"./portfolio/3-columns/3_col_12.jpg": 21837,
	"./portfolio/3-columns/3_col_2.jpg": 60968,
	"./portfolio/3-columns/3_col_3.jpg": 71421,
	"./portfolio/3-columns/3_col_4.jpg": 25699,
	"./portfolio/3-columns/3_col_5.jpg": 26545,
	"./portfolio/3-columns/3_col_6.jpg": 97856,
	"./portfolio/3-columns/3_col_7.jpg": 51624,
	"./portfolio/3-columns/3_col_8.jpg": 76202,
	"./portfolio/3-columns/3_col_9.jpg": 41173,
	"./portfolio/full-width/full_1.jpg": 1153,
	"./portfolio/full-width/full_10.jpg": 92361,
	"./portfolio/full-width/full_11.jpg": 72579,
	"./portfolio/full-width/full_12.jpg": 63707,
	"./portfolio/full-width/full_2.jpg": 45658,
	"./portfolio/full-width/full_3.jpg": 25862,
	"./portfolio/full-width/full_4.jpg": 94787,
	"./portfolio/full-width/full_5.jpg": 35774,
	"./portfolio/full-width/full_6.jpg": 86901,
	"./portfolio/full-width/full_7.jpg": 62364,
	"./portfolio/full-width/full_8.jpg": 40417,
	"./portfolio/full-width/full_9.jpg": 70164,
	"./pos/High-end-all-in-one-dual-screen.png": 46932,
	"./pos/b_dashboard.png": 21152,
	"./pos/cash-register.png": 47952,
	"./pos/chat.png": 39519,
	"./pos/credit-card.png": 35189,
	"./pos/delivery-truck.png": 85246,
	"./pos/ezgif-1-997e5035cba4.png": 10358,
	"./pos/fotter_shap.png": 9260,
	"./pos/icon1.png": 10193,
	"./pos/icon2.png": 77801,
	"./pos/icon3.png": 70235,
	"./pos/item1.png": 18305,
	"./pos/item2.png": 23558,
	"./pos/item3.png": 3617,
	"./pos/laptop.png": 78050,
	"./pos/leaf-left.png": 83189,
	"./pos/leaf-right.png": 18264,
	"./pos/mailbox.png": 21375,
	"./pos/man.png": 88652,
	"./pos/pattern_01.png": 24533,
	"./pos/pattern_02.png": 7862,
	"./pos/people.png": 38853,
	"./pos/pos.png": 64641,
	"./pos/pos_about_img.png": 48103,
	"./pos/pos_blog_1.png": 2378,
	"./pos/pos_blog_2.png": 5418,
	"./pos/pos_blog_3.png": 54544,
	"./pos/pos_slideshow1.jpg": 88886,
	"./pos/pos_slideshow2.jpg": 97256,
	"./pos/pos_slideshow3.jpg": 70583,
	"./pos/shape.png": 81969,
	"./pos/shape_bg.png": 45685,
	"./pos/statistics.png": 90058,
	"./pos/tab_pattern.png": 71446,
	"./pos/wave_two.png": 51042,
	"./pos/women.png": 703,
	"./price/one.png": 90115,
	"./price/three.png": 21772,
	"./price/two.png": 62001,
	"./process/ASAN-logo-icon.png": 90723,
	"./process/Avast_Antivirus.png": 43625,
	"./process/UTorrent_(logo).png": 85694,
	"./process/btFMmsoh.png": 33335,
	"./process/logo-slack.png": 2130,
	"./process/png-logo-design.png": 75935,
	"./qoute.png": 99621,
	"./saas/map.png": 76425,
	"./seo/bike.png": 8835,
	"./seo/car.png": 68233,
	"./seo/cloud.png": 7250,
	"./seo/cloud_bg.png": 98100,
	"./seo/features_img.png": 42581,
	"./seo/features_img_two.png": 80872,
	"./seo/footer_bg.png": 71248,
	"./seo/icon1.png": 55034,
	"./seo/icon2.png": 34058,
	"./seo/icon3.png": 73138,
	"./seo/icon4.png": 57035,
	"./seo/icon5.png": 37603,
	"./seo/image.png": 55433,
	"./seo/logo_01.png": 34914,
	"./seo/logo_02.png": 96804,
	"./seo/logo_03.png": 62654,
	"./seo/logo_04.png": 4662,
	"./seo/logo_05.png": 73899,
	"./seo/logo_06.png": 59116,
	"./seo/logo_07.png": 66557,
	"./seo/logo_08.png": 46894,
	"./seo/logo_09.png": 48451,
	"./seo/shap.png": 13995,
	"./seo/studies_img_one.jpg": 65060,
	"./seo/studies_img_three.jpg": 19236,
	"./seo/studies_img_two.jpg": 97517,
	"./seo/triangle_one.png": 96281,
	"./seo/triangle_three.png": 97101,
	"./seo/triangle_two.png": 25556,
	"./svg.svg": 6763,
	"./teams/team_01.jpg": 43308,
	"./teams/team_02.jpg": 52994,
	"./teams/team_03.jpg": 89159,
	"./teams/team_04.jpg": 47214,
	"./teams/team_10.jpg": 31843,
	"./teams/team_12.jpg": 79060,
	"./teams/team_5.jpg": 12787,
	"./teams/team_6.jpg": 25835,
	"./teams/team_7.jpg": 53926,
	"./teams/team_8.jpg": 79522,
	"./teams/team_9.jpg": 51021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;